import fromPairs from 'lodash-es/fromPairs';
import {
  ILoadable,
  LoadableStatus,
} from '../../Utils';
import {
  ILayoutData,
} from '../fetchedData/layoutData';
import {
  RelatedNodesMap,
} from './Utils';

const appendNodeToMapKey = (map: Record<string, Set<number>>, key: number, value: number) => {
  if (map[key] === undefined) {
    map[key] = new Set<number>();
  }
  map[key].add(value);
};

const getRelatedNodes = (
  inputStatus: ILoadable<ILayoutData>,
): ILoadable<RelatedNodesMap> => {

  let result: ILoadable<RelatedNodesMap>;
  if (inputStatus.status === LoadableStatus.Initial) {
    result = {status: LoadableStatus.Initial};
  } else if (inputStatus.status === LoadableStatus.Loading) {
    result = {status: LoadableStatus.Loading};
  } else if (inputStatus.status === LoadableStatus.NotPresent) {
    result = {status: LoadableStatus.NotPresent};
  } else {
    const {data: {edges}} = inputStatus;

    const intermediateMap: Record<string, Set<number>> = {};
    for (const {source, target} of edges) {
      appendNodeToMapKey(intermediateMap, source, target);
      appendNodeToMapKey(intermediateMap, target, source);
    }

    const outputPairs: Array<[string, number[]]> = Object.entries(intermediateMap).map(
      ([key, valuesSet]) => ([key, [...valuesSet]] as [string, number[]]),
    );
    const output: Record<string, number[]> = fromPairs(outputPairs);

    result = {
      status: LoadableStatus.Present,
      data: output,
    };
  }
  return result;
};

export default getRelatedNodes;
